import type { ImgHTMLAttributes } from "react";

const brandMarkUrl = new URL("../../assets/conferis-mark.svg", import.meta.url).href;

export function BrandMark({ className, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <img
      {...props}
      className={["ui-brand-mark", className].filter(Boolean).join(" ")}
      src={brandMarkUrl}
      alt=""
      aria-hidden="true"
    />
  );
}
